let selectScroll = {}
selectScroll.install = function (Vue) {
  // 必须出现滚动跳才可触发
  Vue.directive('selectScroll', {
    bind: (el, binding) => {
      try {
        // 是否执行回调事件
        // 以后绑定的哪个dom就将该DOM绑定给directive
        const elDom = el.querySelector('.el-scrollbar__wrap')
        // 监听滚动事件
        if (!elDom) {
          return
        }
        elDom.onscroll = (e) => {
          // 获取当前节点可滚动的距离
          const scrollHeight = e.target.scrollHeight - e.target.clientHeight
          // 获取节点剩余可滚动的高度
          const residualHeight = scrollHeight - e.target.scrollTop
          //  滚动到指定区域执行回调事件
          if ((typeof binding.value == 'function') && residualHeight <= 10) {
            // 执行事件回调函数
            binding.value()
          }
        }
      } catch (error) {
        console.info('error selectScroll bind', error)
      }
    }
  })
}
export default selectScroll
